export enum NotePermissions {
  CREATE_EXTERNAL_NOTES = "create_external_notes",
  VIEW_EXTERNAL_NOTES = "view_external_notes",
  VIEW_PDF_NOTES = "view_pdf_notes",
  CREATE_PDF_NOTES = "create_pdf_notes",
  CREATE_NOTES = "create_notes",
  VIEW_NOTES = "view_notes",
}
